export default __webpack_public_path__ + "static/media/tour2.6b933245.png";